import { toLower } from 'lodash';
import { createAction } from 'redux-actions';
import { ProgressActionTypes as act } from 'src/redux/modules/progress';
import {
  APP_LOADED,
  BUY,
  chatTitle,
  SELL,
  SELL_TRANSACTION,
} from 'src/settings/settings';
import { transactionType } from 'src/utils/transactions-util';
import { v4 as uuidv4 } from 'uuid';

const chatStart = 'Step';
export const CHAT_CONTEXT =
  transactionType() === SELL_TRANSACTION
    ? toLower(`${SELL}-${chatStart}`)
    : toLower(`${BUY}-${chatStart}`);
export const CHAT_CONTEXT_ALL = `${CHAT_CONTEXT}all`;
const CHAT_TITLE = chatTitle[transactionType()];
const SET_CHAT_CLOSED = 'SET_CHAT_CLOSED';
const SET_CHAT_OPEN = 'SET_CHAT_OPEN';
const STORE_FAQ_LIST = 'STORE_FAQ_LIST';
const STORE_SELECTED_FAQ = 'STORE_SELECTED_FAQ';
const STORE_SESSION_ID = 'STORE_SESSION_ID';
const TOGGLE_CHAT = 'TOGGLE_CHAT';
const UPDATE_CHAT_CONTEXT = 'UPDATE_CHAT_CONTEXT';

export default function chat(
  state = {
    context: '',
    faqList: null,
    open: false,
    selectedFAQ: null,
    selectedHeading: null,
    sessionId: null,
    title: CHAT_TITLE,
  },
  { type, payload }
) {
  switch (type) {
    case `${APP_LOADED}_FULFILLED`:
      return {
        ...state,
        sessionId: uuidv4(),
      };
    case `${SET_CHAT_OPEN}_FULFILLED`:
      return {
        ...state,
        open: true,
      };
    case `${SET_CHAT_CLOSED}_FULFILLED`:
      return {
        ...state,
        open: false,
      };
    case `${TOGGLE_CHAT}_FULFILLED`:
      return {
        ...state,
        open: !state.open,
      };
    case `${STORE_FAQ_LIST}_FULFILLED`:
      return {
        ...state,
        faqList: payload,
      };
    case `${STORE_SELECTED_FAQ}_FULFILLED`:
      return {
        ...state,
        selectedHeading: payload.heading,
        selectedFAQ: payload.question,
      };
    case `${act.SET_PROGRESS}_FULFILLED`: {
      // Early exit for non Sell transactions
      // Only Sell has chat option for now
      if (transactionType() !== SELL_TRANSACTION) {
        return state;
      }
      let { currentStep } = payload;
      if (currentStep === 0) {
        currentStep++;
      }
      const context = `${CHAT_CONTEXT}${currentStep}`;
      return {
        ...state,
        context,
      };
    }
    case `${STORE_SESSION_ID}_FULFILLED`:
      return {
        ...state,
        sessionId: payload,
      };
    case `${UPDATE_CHAT_CONTEXT}_FULFILLED`: {
      return {
        ...state,
        context: payload,
      };
    }
    default:
      return state;
  }
}

export const openChat = () => {
  return (dispatch) => {
    const action = createAction(`${SET_CHAT_OPEN}_FULFILLED`)(null);
    dispatch(action);
  };
};

export const storeFAQList = (list) => {
  return (dispatch) => {
    const action = createAction(`${STORE_FAQ_LIST}_FULFILLED`)(list);
    dispatch(action);
  };
};

export const storeSelectedFAQ = (question, heading) => {
  const payload = {
    question,
    heading,
  };
  return (dispatch) => {
    const action = createAction(`${STORE_SELECTED_FAQ}_FULFILLED`)(payload);
    dispatch(action);
  };
};

export const storeChatSessionId = (sessionId) => {
  return (dispatch) => {
    const action = createAction(`${STORE_SESSION_ID}_FULFILLED`)(sessionId);
    dispatch(action);
  };
};

export const closeChat = () => {
  return (dispatch) => {
    const action = createAction(`${SET_CHAT_CLOSED}_FULFILLED`)(null);
    dispatch(action);
  };
};

export const toggleChat = () => {
  return (dispatch) => {
    const action = createAction(`${TOGGLE_CHAT}_FULFILLED`)(null);
    dispatch(action);
  };
};

export const updateChatContext = (context) => {
  return (dispatch) => {
    const action = createAction(`${UPDATE_CHAT_CONTEXT}_FULFILLED`)(context);
    dispatch(action);
  };
};
